import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/tailwind.css");
